import React from 'react';

// Wraps any Lucide icon in the brand gradient (#7852F8 -> #84AEF6), the same one
// StartupLogoPlaceholderIcon uses - so placeholder and empty-state icons all read
// as one family.
//
// Lucide sets `stroke` on the root <svg> and its paths inherit it, so pointing
// that at a gradient url and passing the <defs> in as children is enough. The
// gradient id is per-instance: several of these can render on one page, and a
// shared id would make every copy inherit whichever <defs> mounted last.
const GradientIcon = ({ icon: Icon, size = 26, strokeWidth = 1.6 }) => {
  const uid = React.useId();
  const gradientId = `gradient_icon_${uid}`;
  return (
    <Icon
      size={size}
      strokeWidth={strokeWidth}
      stroke={`url(#${gradientId})`}
      aria-hidden="true"
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export default GradientIcon;
